export default __webpack_public_path__ + "static/media/red.3c40dea2.svg";